import type { ApiCountryCode } from '../types';

const MAX_COUNTRY_CODE_LENGTH = 3;

export function splitPhoneNumberByCountryCode(
  fullNumber: string,
  phoneCodes: ApiCountryCode[],
): { countryCode: string; nationalNumber: string } {
  const digits = fullNumber.replace(/[^\d]/g, '');
  const knownCodes = new Set<string>();
  phoneCodes.forEach((entry) => {
    knownCodes.add(entry.countryCode);
    entry.prefixes?.forEach((prefix) => knownCodes.add(prefix));
  });

  // Known country codes are at most `MAX_COUNTRY_CODE_LENGTH` digits; matching longest-first avoids
  // a short code like "1" wrongly swallowing a longer prefix like "86".
  for (let len = MAX_COUNTRY_CODE_LENGTH; len >= 1; len -= 1) {
    const candidate = digits.slice(0, len);
    if (knownCodes.has(candidate)) {
      return { countryCode: candidate, nationalNumber: digits.slice(len) };
    }
  }

  throw new Error(`No known country code prefixes phone number: ${fullNumber}`);
}
